import { InternalAxiosRequestConfig } from "axios";
import { fetchAuthSession } from "aws-amplify/auth";

const axiosJwtInterceptor = async (config: InternalAxiosRequestConfig) => {
  try {
    // save token
    const session = await fetchAuthSession({
      forceRefresh: !!config.params?.refreshToken,
    });

    const token = session.tokens?.idToken;

    if (token) {
      config!.headers!.Authorization = `Bearer ${token}`;
    } else {
      config.headers.Authorization = "";
    }
  } catch (error) {
    console.log(error);
  }

  return config;
};

export default axiosJwtInterceptor;
